/*
#*===================================================================
#*
#* Licensed Materials - Property of GameTimeFootage Inc.
#*
#* Copyright NextPro 2018. All Rights Reserved.
#*
#*===================================================================
*/
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromGetGames from 'app/library/store/actions/get-library-games.action';

export interface GetLibraryGamesState extends EntityState<any> {
  selectedLibraryGameId: number | null;
  lastViewedGameId: number | null;
  errorMessage: string;
  success: boolean;
  loading: boolean;
}

export const libraryGamesAdapter: EntityAdapter<any> = createEntityAdapter<any>();

export const defaultLibraryGame: GetLibraryGamesState = {
  ids: [],
  entities: {},
  selectedLibraryGameId: null,
  lastViewedGameId: null,
  errorMessage: null,
  success: false,
  loading: false,
};

export const initialState = libraryGamesAdapter.getInitialState(defaultLibraryGame);

export function reducer(state = initialState, action: fromGetGames.GetLibraryGamesAction): GetLibraryGamesState {
  switch (action.type) {
    case fromGetGames.GET_LIBRARY_GAMES: {
      return {
        ...state,
        ids: [],
        entities: {},
        errorMessage: null,
        loading: true,
        success: false,
      };
    }

    case fromGetGames.GET_LIBRARY_GAMES_FAIL: {
      return {
        ...state,
        ids: [],
        entities: {},
        errorMessage: action.payload,
        loading: false,
        success: false,
      };
    }

    case fromGetGames.GET_LIBRARY_GAMES_SUCCESS: {
      return libraryGamesAdapter.setAll(action.payload, {
        ...state,
        errorMessage: null,
        loading: false,
        success: true,
      });
    }

    case fromGetGames.RESET_LIBRARY_GAMES: {
      return {
        ...defaultLibraryGame,
      };
    }

    case fromGetGames.ADD_LIBRARY_GAME: {
      return libraryGamesAdapter.addOne(action.payload, {
        ...state,
        errorMessage: null,
        loading: false,
        success: true,
      });
    }

    case fromGetGames.SET_LAST_VIEWED_GAME: {
      return {
        ...state,
        lastViewedGameId: action.payload,
      };
    }
  }

  return state;
}

const getLibraryGamesFeatureState = createFeatureSelector<GetLibraryGamesState>('libraryGames');

export const getClipsData = createSelector(getLibraryGamesFeatureState, libraryGamesAdapter.getSelectors().selectAll);

export const getClipsErrorMessage = createSelector(
  getLibraryGamesFeatureState,
  (state: GetLibraryGamesState) => state.errorMessage
);
export const getClipsLoading = createSelector(
  getLibraryGamesFeatureState,
  (state: GetLibraryGamesState) => state.loading
);
export const getClipsSuccess = createSelector(
  getLibraryGamesFeatureState,
  (state: GetLibraryGamesState) => state.success
);
